import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { FileText, Loader2 } from 'lucide-react';
import SubmissionRow from './SubmissionRow';

const SubmissionsTable = ({ 
  submissions, 
  loading, 
  onEdit, 
  onDelete 
}) => {
  if (loading) {
    return (
      <Card className="border-0 shadow-sm">
        <CardContent className="p-4">
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-[#1877F2]" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">
          Contact Requests
          <span className="text-gray-500 font-normal ml-2">({submissions.length} requests)</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {submissions.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <FileText className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>No submissions found</p>
          </div>
        ) : (
          <div className="space-y-3">
            {submissions.map((submission) => (
              <SubmissionRow
                key={submission.id}
                submission={submission}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SubmissionsTable;
